<template>
<div class="creek-volume-control" v-on:click.prevent="onIconClick" v-on:mouseover.prevent="onIconMouseOver" v-on:mouseleave.prevent="onIconMouseLeave">
  <button class="button button-small" type="button">
  <div class="volume-control-icon" :class="{ mute: isMute }">
    <i class="fa" :class="[volumeIcon]"></i>
    <span class="volume-control-icon-mute" v-if="isMute"></span>
  </div>
  </button>
  <div class="volume-control-bar-wrapper" :style="{display: isBarVisible ? 'block' : 'none'}" v-on:click.prevent.stop>
    <div class="volume-control-bar" ref="volumeBar">
      <div class="volume-control-bar-clickable" v-on:mousedown.prevent.stop="onBarMouseDown" v-on:mouseup.prevent.stop="onBarMouseUp" v-on:mousemove.prevent.stop="onBarMouseMove" v-on:mouseleave.prevent="onBarMouseLeave"></div>
      <div class="volume-control-bar-filler" :style="{ height: barFillerHeight }"></div>
    </div>
  </div>
</div>
</template>

<style lang="stylus" scoped>

  /* volume control */
  .creek-volume-control
    
    float left
    position relative
    margin 6px 8px
    
    button.button-small
      border-radius: 4px
      background none
      padding 0 4px
      
    button:active, button:focus
      outline: none
      
    @media screen and (max-width: 600px)
      display none

  .volume-control-icon
    width 38px
    font-size 29px
    margin-right 1px
    cursor pointer
    opacity 0.8
    position relative
    padding 6px 0
    &:hover
      opacity 1
    &.mute
      color #999
    .volume-control-icon-mute
      display block
      width 47px
      height 3px
      background #999
      position absolute
      top 19px
      left -3px
      transform rotate(45deg)
    
    
  .volume-control-bar-wrapper
    padding 7px
    background #fff
    // border 1px solid #bbb
    border-radius 10px 10px 0 0
    position absolute
    top -114px
    left 10px
    box-shadow 0 2px 14px rgba(0,0,0,.3) 
    
  .volume-control-bar
    width 16px
    height 100px
    background #ddd
    // border 1px solid #bbb
      
    border-radius 4px 4px 0 0
    position relative
    overflow hidden
    cursor pointer

  .volume-control-bar-clickable
    box-sizing border-box
    height 100px
    width 16px
    position absolute
    left 0
    bottom 0
    z-index 2

  .volume-control-bar-filler
    box-sizing border-box
    width 16px
    // height 50px
    background #65a6e8
    // border-top 3px solid #ddd
    position absolute
    left 0
    bottom 0
    z-index 1

</style>

<script type="text/javascript">
export default {

  name: 'creek-audio-toolbar-volume',

  data () {
    return {
      volume: 1.0,
      volumeBeforeMute: 1,
      isBarVisible: false,
      volumeDragging: false
    }
  },

  computed: {

    volumeIcon () {
      if (this.volume > .5) return 'fa-volume-up'
      else if (this.volume > 0) return 'fa-volume-down'
      else return 'fa-volume-up'
    },

    barFillerHeight () {
      return (100 * this.volume) + 'px';
    },

    isMute () {
      return this.volume == 0
    }

  },

  watch: {

    volume() {

      // Update volume on global audio
      if(this.Creek.audio && typeof this.Creek.audio.volume == "function"){
        this.Creek.audio.volume(this.volume);
        // this.Creek.debug.log("Volume in Component: " + this.Creek.audio.volume());
      }

      return this.volume;

    }

  },

  methods: {

    onIconMouseOver () {
      this.isBarVisible = true
    },

    onIconMouseLeave () {
      this.isBarVisible = false
    },

    onIconClick () {
      if (this.isMute) {
        this.volume = this.volumeBeforeMute > 0.2 ? this.volumeBeforeMute : 0.2;
      } else {
        this.volumeBeforeMute = this.volume
        this.volume = 0
      }
    },

    onBarMouseDown: function(event) {
      this.volumeDragging = true
      this.dragVolume(event)
    },

    onBarMouseUp: function(event) {
      this.volumeDragging = false
      // console.log(event)
      // console.log(this.volume)
    },

    onBarMouseMove: function(event) {
      if (this.volumeDragging){
          this.dragVolume(event)
      }
    },

    onBarMouseLeave: function(event) {
      this.volumeDragging = false
    },

    dragVolume: function(event) {

      // var vol = 0.00;

      // console.log(posY)

      // var clickWhere = 1 event.posY;
      // var clickWhere = event.pageY - posY;
      var vol = (100 - event.offsetY) / 100;
      
      // console.log(this.$refs.volumeBar.clientHeight)
      // console.log(event)
      // console.log(event.offsetY)
      // console.log(this.$refs.volumeBar.offsetY)
      // console.log(event)
      // console.log(event.posY)
      // console.log(vol)

      this.volume = vol;

      // Snap to volume off position.
      if (this.volume <= 0.04) {
        this.volume = 0
      }
      this.volumeBeforeMute = this.volume;

    }

  }

}

</script>
